export default {
    filters: {
        fileFilter(fileRelativePath) {
            return process.env.VUE_APP_imagePath + fileRelativePath;
        }
    }
};
